import {
  useGetMasterDistrict,
  useGetMasterProvice,
  useGetMasterSubDistrict,
  useGetZipcode,
} from "hooks/useMasterData";
import {
  AddressFacData,
  MasterDistrictData,
  MasterProvinceData,
  MasterSubDistrictData,
  MasterZipcodeData,
} from "services/interface";
import { Col, Form, Input, Row, Select, Spin } from "antd";
import { FormInstance, Rule } from "antd/es/form";
import React, { FC, useEffect, useState } from "react";

const { Option } = Select;

const ruleRequired: Rule = {
  required: true,
  message: "โปรดระบุ",
};

interface FactoryAddressProps {
  form: FormInstance
  address_fac: AddressFacData | undefined;
  disabled?: boolean;
}

const FactoryAddress: FC<FactoryAddressProps> = ({ form, address_fac, disabled }) => {
  const [province, setProvince] = useState<MasterProvinceData[]>([]);
  const [district, setDistrict] = useState<MasterDistrictData[]>([]);
  const [subDistrict, setSubDistrict] = useState<MasterSubDistrictData[]>([]);
  const [zipcodeData, setZipcodeData] = useState<MasterZipcodeData[]>([]);

  const [proviceId, setProviceId] = useState<number>(0);
  const [districtId, setDistrictId] = useState<number>(0);
  const [zipCode, setZipCode] = useState<number>(0);

  const { data: masterProviceData, isLoading: proviceLoading } =
    useGetMasterProvice();

  useEffect(() => {
    if (masterProviceData) {
      setProvince(masterProviceData);
    }
  }, [masterProviceData]);

  const childrenProvince: React.ReactNode[] = [];
  province?.map((item) => {
    childrenProvince.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const { data: masterDistrictData, isLoading: districtLoading } =
    useGetMasterDistrict(proviceId);

  useEffect(() => {
    if (masterDistrictData) {
      setDistrict(masterDistrictData);
    }
  }, [masterDistrictData]);

  const childrenDistrict: React.ReactNode[] = [];
  district?.map((item) => {
    childrenDistrict.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const { data: masterSubDistrictData, isLoading: subDistrictLoading } =
    useGetMasterSubDistrict(districtId);

  useEffect(() => {
    if (masterSubDistrictData) {
      setSubDistrict(masterSubDistrictData);
    }
  }, [masterSubDistrictData]);

  const childrenSubDistrict: React.ReactNode[] = [];
  subDistrict?.map((item) => {
    childrenSubDistrict.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });


  useEffect(() => {
    setProviceId(address_fac?.province_id ?? 0);
    setDistrictId(address_fac?.district_id ?? 0);
  }, [address_fac]);



  return (
    <>
      <Form.Item
        label="ที่อยู่"
        name="line_1"
        labelAlign="left"
        rules={[{ required: false, message: "กรุณากรอกที่อยู่" }]}
      >
        <Input placeholder="ที่อยู่" showCount maxLength={120} size="small" disabled={disabled} />
      </Form.Item>

      <Form.Item label="จังหวัด"  labelAlign="left" name="province_id" rules={[ruleRequired]}>
        <Select
          showSearch
          placeholder="จังหวัด"
          optionFilterProp="children"
          disabled={disabled}
          onChange={(value) => {
            setProviceId(value);
            form.setFieldsValue({ district_id: undefined });
            form.setFieldsValue({ sub_district_id: undefined });
            form.setFieldsValue({ zip_code: undefined });
          }}
          notFoundContent={proviceLoading ? <Spin size="small" /> : null}
          loading={proviceLoading}
        >
          {childrenProvince}
        </Select>
      </Form.Item>

      <Form.Item label="อำเภอ" labelAlign="left" name="district_id" rules={[ruleRequired]}>
        <Select
          showSearch
          placeholder="อำเภอ"
          optionFilterProp="children"
          disabled={disabled}
          onChange={(value) => {
            setDistrictId(value);
            form.setFieldsValue({ sub_district_id: undefined });
            form.setFieldsValue({ zip_code: undefined });
          }}
          notFoundContent={districtLoading ? <Spin size="small" /> : null}
          loading={districtLoading}
        >
          {childrenDistrict}
        </Select>
      </Form.Item>

      <Form.Item label="ตำบล" labelAlign="left"  name="sub_district_id" rules={[ruleRequired]}>
        <Select
          showSearch
          placeholder="ตำบล"
          optionFilterProp="children"
          disabled={disabled}
          onChange={(value) => {
            subDistrict.map((item) => {
              if (item.id == value) {
               // setZipCode(item.zip_code);
                form.setFieldsValue({ zip_code: item.zip_code });
              }
            });
          }}
          notFoundContent={subDistrictLoading ? <Spin size="small" /> : null}
          loading={subDistrictLoading}
        >
          {childrenSubDistrict}
        </Select>
      </Form.Item>

      <Form.Item label="รหัสไปรษณีย์" labelAlign="left" name="zip_code" rules={[ruleRequired]}>
        <Input placeholder="รหัสไปรษณีย์" maxLength={5} minLength={5} disabled={disabled} />
      </Form.Item>
    </>
  );
};

export default FactoryAddress;
